
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/otc-landing",
      function () {
        return require("private-next-pages/otc-landing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/otc-landing"])
      });
    }
  